import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router';

import { StyledBtnService } from './styles/StyledBtnService';

class BtnService extends Component {
  render() {
    const { title, officeId, serviceId, servicesGroups, } = this.props;

    return (
      <StyledBtnService
        servicesGroups={servicesGroups}
      >
        <div className="disable-select btn-service-container">
          <Link className="btn-service-content"
            to={'/office/' + officeId + '/service/' + serviceId}
          >
            <table className="btn-service-table">
              <tbody>
                <tr>
                  <td className="btn-service-title">
                  { title }
                  </td>
                  <td className="btn-service-arrow">
                    <i className="fa fa-angle-right" aria-hidden="true"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </Link>
        </div>
      </StyledBtnService>
    );
  }
}


BtnService.propTypes = {
  title: PropTypes.string.isRequired,
  officeId: PropTypes.string,
  serviceId: PropTypes.number.isRequired,
  servicesGroups: PropTypes.bool.isRequired,
};


export default BtnService;



// WEBPACK FOOTER //
// ./src/common/BtnService/BtnService.js